import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddComment from "../components/AddComment";
import ShowComment from "../components/ShowComment";
import { UserAuth } from "../Context";
import {
  doc,
  getDoc,
  collection,
  getCountFromServer,
  increment,
  serverTimestamp,
  runTransaction,
} from "firebase/firestore";
import { db } from "../FirebaseConfig";
import useModalStore from "../StatesStore/ModalStore";
import { dataFeedReaction, titleFeedReaction } from "../Content/ModalContent";
import CommentModal from "../Modals/CommentModal";
import useNotification from "../hooks/useNotification";
import usePoints from "../hooks/user/usePoints";
import usePointsStore from "../StatesStore/PointsTable";
import useFeedNotification from "../hooks/useFeedNotification";
import usePostAction from "../hooks/usePostAction";
import ShowComment2 from "../components/ShowComment2";
import { toastOptions } from "../lib/toastOptions";
import { toast } from "react-toastify";
import { usePointsSystem } from "../Points/usePointsSystem";

export default function FeedReaction3({
  post,
  commentCount,
  setCommentCount,
  componentName,
}) {
  // console.log("I am from feed Reaction");
  const { user } = UserAuth();
  const [isLiked, setIsLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(0);

  const [productData, setproductData] = useState();
  const { openModal } = useModalStore();
  const { addNotification, deleteNotification } = useNotification();
  const { addFeedNotification, deleteFeedNotification } = useFeedNotification();
  const {
    addPostActionNotification,
    deletePostActionNotification,
  } = usePostAction();
  const { addPoints, removePoints } = usePoints();
  const pointsTable = usePointsStore((state) => state.pointsTable);
const { awardPoints } = usePointsSystem(user?.uid);
  const [User, setUser] = useState(user);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [visibleComments, setVisibleComments] = useState(3);
  const handleShow = () => setShowCommentModal(true);
  const handleClose = () => {
    setShowCommentModal(false);
    setVisibleComments(3);
  };
  const handleClick = () => {
    if (!user) {
      // Check if user is not logged in before opening modal
      openModal("SignInModal", titleFeedReaction, dataFeedReaction); // Open modal here
    }
  };
  // console.log("Post from feed reaction", post);
  const likePost = async () => {
    if (user) {
      const postRef = doc(db, "posts", post?.id);
      const reactionRef = doc(db, "posts", post?.id, "reactions", user?.uid);

      try {
        await runTransaction(db, async (transaction) => {
          const reactionSnapshot = await transaction.get(reactionRef);

          if (reactionSnapshot.exists()) {
            // If the reaction already exists, remove it and decrement reactionCount
            setLikesCount((prevCount) => prevCount - 1);
            setIsLiked(false);
            transaction.delete(reactionRef);
            transaction.update(postRef, {
              reactionCount: increment(-1),
            });

            if (post?.userId !== user?.uid) {
              await deleteNotification({
                userId: post?.userId,
                id: user?.uid,
                type: "postLike",
                by: "user",
                fields: {
                  postId: post?.id,
                },
              });
            }

            //deleting points
            const postingPoints = pointsTable.likeAPostByOtherUser || 0;
            removePoints({
              userId: post?.userId,
              type: "likeAPostByOtherUser",
              pointsRemoved: postingPoints,
              fields: {
                postId: post?.id,
                likedBy: user?.uid,
              },
            });

            deleteFeedNotification({
              ownerId: post?.userId,
              id: user?.uid,
              type: "postLike",
              by: "user",
              fields: {
                postId: post?.id,
              },
            });

            deletePostActionNotification({
              ownerId: post?.userId,
              actionUserId: user?.uid,
              actionType: "postComment",
              by: "user",
              postId: post?.id,
            });
          } else {
            // If no reaction exists, add it and increment reactionCount
            setLikesCount((prevCount) => prevCount + 1);
            setIsLiked(true);
            transaction.set(reactionRef, {
              timestamp: serverTimestamp(),
              type: "like",
            });
            transaction.update(postRef, {
              reactionCount: increment(1),
            });

            // Add notification if it's not the user's own post
            if (post?.userId !== user.uid) {
              awardPoints('likePost')
              await addNotification({
                userId: post?.userId,
                id: user?.uid,
                timestamp: serverTimestamp(),
                type: "postLike",
                by: "user",
                fields: {
                  postId: post?.id,
                },
              });

              //adding points
              const postingPoints = pointsTable.likeAPostByOtherUser || 0;

              addPoints({
                userId: post?.userId,
                type: "likeAPostByOtherUser",
                pointsAwarded: postingPoints,
                fields: {
                  postId: post?.id,
                  likedBy: user?.uid,
                },
              });

              addFeedNotification({
                ownerId: post?.userId,
                id: user?.uid,
                type: "postLike",
                by: "user",
                fields: {
                  postId: post?.id,
                },
              });
            }
            addPostActionNotification({
              ownerId: post?.userId,
              actionUserId: user?.uid,
              actionType: "postLike",
              by: "user",
              postId: post?.id,
            });
          }
        });

        // External like product logging API
        if (productData) {
          await fetch(process.env.REACT_APP_API + `/api/brandLog/${user.uid}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              brandName: productData.supplier,
              categories: productData.category,
              subCategories: productData.subCategory,
              subSubCategories: productData.subSubCategory,
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("Like product logging response:", data);
            })
            .catch((error) => {
              console.error("Error calling like product logging API:", error);
            });
        }
      } catch (error) {
        console.error("Transaction failed: ", error);
      }
    }
  };

  useEffect(() => {
    const fetchLikes = async () => {
      try {
        const postRef = doc(db, "posts", post?.id);
        const postSnapshot = await getDoc(postRef);
        const postData = postSnapshot.data();

        // Fetching the reactionCount directly from the post document
        if (postData) {
          setLikesCount(postData.reactionCount || 0); // Use reactionCount

          // Check if the user has liked the post by looking for the document in 'reactions'
          const reactionRef = doc(
            db,
            "posts",
            post?.id,
            "reactions",
            user?.uid
          );
          const reactionSnapshot = await getDoc(reactionRef);
          setIsLiked(reactionSnapshot.exists()); // Set whether the user has liked the post
        }
      } catch (error) {
        console.error("Error fetching likes:", error);
      }
    };

    if (post?.id && user?.uid) {
      fetchLikes();
    }
  }, [post?.id, user?.uid]);

  useEffect(() => {
    const getCount = async () => {
      try {
        const postRef = doc(db, "posts", post?.id);
        const commentsCollectionRef = collection(postRef, "comments");
        const snapshot = await getCountFromServer(commentsCollectionRef);
        setCommentCount(snapshot.data()?.count);
      } catch (error) {
        console.error("Error getting comment count:", error);
      }
    };
    getCount();
  }, [post?.id]);
  const handleCopyLink = async () => {
    try {
      const currentUrl = window.location.href;
      await navigator.clipboard.writeText(currentUrl);
      toast.success("Link copied successfully", toastOptions);
    } catch (error) {
      console.error("Failed to copy link: ", error);
      toast.error("Failed to copy link", toastOptions); // Optional: show error toast
    }
  };
  return (
    <>
      <span
        className="mt-2"
        style={{
          fontWeight: 500,
          fontSize: "12px",
          color: "#000000",
        }}
      >
        {likesCount} Like{likesCount !== 1 ? "s" : ""}{" "}
        <svg
          width="8"
          height="3"
          viewBox="0 0 8 3"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.00152403 2.71351C-0.0134622 2.09009 0.0820744 1.57838 0.288134 1.17838C0.49794 0.778379 0.77893 0.482883 1.1311 0.291892C1.48328 0.0972976 1.87104 0 2.2944 0C2.66906 0 3.01561 0.0774778 3.33407 0.232433C3.65252 0.383784 4.01594 0.632432 4.42431 0.978378C4.67907 1.19099 4.88701 1.34595 5.04811 1.44324C5.20921 1.53694 5.38904 1.58378 5.58761 1.58378C5.89108 1.58378 6.13273 1.47568 6.31256 1.25946C6.49614 1.03964 6.58419 0.715315 6.57669 0.286486H7.9985C8.01349 0.913513 7.91608 1.42703 7.70627 1.82703C7.50021 2.22703 7.21922 2.52252 6.8633 2.71351C6.51113 2.9045 6.12524 3 5.70562 3C5.32722 3 4.9788 2.92252 4.66034 2.76757C4.34188 2.60901 3.98034 2.36036 3.57572 2.02162C3.31346 1.8018 3.10365 1.64685 2.9463 1.55676C2.78895 1.46306 2.61099 1.41622 2.41242 1.41622C2.12394 1.41622 1.88416 1.51712 1.69308 1.71892C1.50576 1.91712 1.41584 2.24865 1.42333 2.71351H0.00152403Z"
            fill="black"
          />
        </svg>{" "}
        {commentCount} Comment{commentCount !== 1 ? "s" : ""}
      </span>

      <hr className="my-0 mt-1" />
      {/* Feed react START */}
      {/* <ul className="nav nav-stack py-3 small">
        <li className="nav-item">
          <Link className="nav-link ">
            {likesCount > 0 && (
              <i className="bi bi-hand-thumbs-up-fill pe-1"></i>
            )}
            {isLiked && likesCount === 1 ? "You" : " "}
            {isLiked && likesCount > 1
              ? `You and ${likesCount - 1} other${likesCount > 2 ? "s" : ""}`
              : ""}
            {!isLiked && likesCount > 0 ? `${likesCount} ` : ""}
          </Link>
        </li>
        <li className="nav-item ms-sm-auto">
          <a
            className="nav-link mb-0 "
            data-bs-toggle="collapse"
            href={`#multiCollapseExample${post?.id}`}
            role="button"
            aria-expanded="false"
            aria-controls={`multiCollapseExample${post?.id}`}
            hidden={commentCount === 0} // Hide the link if there are no comments
          >
            <i className="bi bi-chat-fill pe-1"> </i>
            {commentCount === 1 ? "1 comment" : `${commentCount} comments`}
          </a>
        </li>
      </ul> */}
      {/* Feed react END */}
      {/* Feed react START */}
      <div
        className={`nav pt-2 mb-0 w-100 d-flex justify-content-between ${
          componentName === "ShoppingListPostCard" ? "pb-2" : "pb-3"
        }`}
      >
        {user && (
          <div
            className="nav-link my-0 pt-0 d-flex align-items-center gap-1 p-0"
            style={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize:
                componentName === "ShoppingListPostCard" ? "14px" : "16px",
              color: "#000000",
              textDecoration: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              likePost();
            }}
          >
            {isLiked ? (
              componentName === "ShoppingListPostCard" ? (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ flexShrink: 0 }}
                >
                  <path
                    d="M4.55814 9.68591L5.1142 9.63784C5.08845 9.34005 4.83269 9.11541 4.53408 9.1283C4.23546 9.14118 4 9.38702 4 9.68591H4.55814ZM17.385 11.0427L16.86 14.0788L17.96 14.2691L18.485 11.2329L17.385 11.0427ZM12.1823 17.8837H8.72287V19H12.1823V17.8837ZM8.04464 17.2605L7.44024 10.2705L6.32811 10.3667L6.93251 17.3566L8.04464 17.2605ZM16.86 14.0788C16.4828 16.2597 14.5163 17.8837 12.1823 17.8837V19C15.0297 19 17.4853 17.0138 17.96 14.2691L16.86 14.0788ZM12.1896 5.86522L11.6965 8.87514L12.7981 9.05563L13.2912 6.04572L12.1896 5.86522ZM7.67459 9.6944L8.74528 8.77179L8.01659 7.92617L6.9459 8.84880L7.67459 9.6944ZM10.6932 5.7699L11.0472 4.40518L9.96674 4.12489L9.61271 5.48961L10.6932 5.7699ZM11.5819 4.13742L11.6898 4.17207L12.0313 3.10929L11.9234 3.07464L11.5819 4.13742ZM10.157 7.14213C10.3891 6.70752 10.5695 6.24717 10.6932 5.7699L9.61271 5.48961C9.51124 5.88079 9.36334 6.25874 9.17241 6.61618L10.157 7.14213ZM11.6898 4.17207C11.9178 4.24533 12.0798 4.42146 12.133 4.62667L13.2135 4.34639C13.0606 3.75697 12.6095 3.29505 12.0313 3.10929L11.6898 4.17207ZM11.0472 4.40518C11.0733 4.3047 11.1459 4.21237 11.2557 4.15947L10.7711 3.15386C10.3751 3.34462 10.0778 3.69676 9.96674 4.12489L11.0472 4.40518ZM11.2557 4.15947C11.3559 4.11115 11.4739 4.10274 11.5819 4.13742L11.9234 3.07464C11.544 2.95278 11.1302 2.9808 10.7711 3.15386L11.2557 4.15947ZM12.8586 10.2441H16.7143V9.12777H12.8586V10.2441ZM5.83725 17.9999L5.1142 9.63784L4.00208 9.73399L4.72513 18.096L5.83725 17.9999ZM5.11628 18.0792V9.68591H4V18.0792H5.11628ZM4.72513 18.096C4.71531 17.9825 4.80481 17.8837 4.92034 17.8837V19C5.4606 19 5.8837 18.537 5.83725 17.9999L4.72513 18.096ZM13.2912 6.04572C13.3839 5.48004 13.3575 4.90123 13.2135 4.34639L12.133 4.62667C12.2379 5.03105 12.2572 5.45292 12.1896 5.86522L13.2912 6.04572ZM8.72287 17.8837C8.37019 17.8837 8.07517 17.6136 8.04464 17.2605L6.93251 17.3566C7.01285 18.2857 7.78992 19 8.72287 19V17.8837ZM8.74528 8.77179C9.25122 8.33581 9.79662 7.81687 10.157 7.14213L9.17241 6.61618C8.91464 7.09873 8.50419 7.50599 8.01659 7.92617L8.74528 8.77179ZM18.485 11.2329C18.675 10.1341 17.83 9.12777 16.7143 9.12777V10.2441C17.1359 10.2441 17.4573 10.6249 17.385 11.0427L18.485 11.2329ZM4.92034 17.8837C5.02915 17.8837 5.11628 17.9718 5.11628 18.0792H4C4 18.5872 4.41145 19 4.92034 19V17.8837ZM11.6965 8.87514C11.5791 9.59171 12.1314 10.2441 12.8586 10.2441V9.12777C12.8214 9.12777 12.7917 9.09414 12.7981 9.05563L11.6965 8.87514ZM7.44024 10.2705C7.42132 10.0518 7.50865 9.83743 7.67459 9.6944L6.9459 8.84880C6.50807 9.22609 6.27832 9.79092 6.32811 10.3667L7.44024 10.2705Z"
                    fill="#005FDA"
                  />
                  <path
                    d="M14.7556 18L8.25563 18.5L7.47215 18L6.96436 10L7.47215 9.5L8.75563 8L10.2556 6.5V4.5L11.2556 3.5L12.2556 4L12.7556 5L12.2556 9.5L12.7556 10L17.2556 9.5L17.7556 10.5L17.2556 15.5L14.7556 18Z"
                    fill="#005FDA"
                  />
                </svg>
              ) : (
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ flexShrink: 0 }}
                >
                  <path
                    d="M4.55814 9.68591L5.1142 9.63784C5.08845 9.34005 4.83269 9.11541 4.53408 9.1283C4.23546 9.14118 4 9.38702 4 9.68591H4.55814ZM17.385 11.0427L16.86 14.0788L17.96 14.2691L18.485 11.2329L17.385 11.0427ZM12.1823 17.8837H8.72287V19H12.1823V17.8837ZM8.04464 17.2605L7.44024 10.2705L6.32811 10.3667L6.93251 17.3566L8.04464 17.2605ZM16.86 14.0788C16.4828 16.2597 14.5163 17.8837 12.1823 17.8837V19C15.0297 19 17.4853 17.0138 17.96 14.2691L16.86 14.0788ZM12.1896 5.86522L11.6965 8.87514L12.7981 9.05563L13.2912 6.04572L12.1896 5.86522ZM7.67459 9.6944L8.74528 8.77179L8.01659 7.92617L6.9459 8.84880L7.67459 9.6944ZM10.6932 5.7699L11.0472 4.40518L9.96674 4.12489L9.61271 5.48961L10.6932 5.7699ZM11.5819 4.13742L11.6898 4.17207L12.0313 3.10929L11.9234 3.07464L11.5819 4.13742ZM10.157 7.14213C10.3891 6.70752 10.5695 6.24717 10.6932 5.7699L9.61271 5.48961C9.51124 5.88079 9.36334 6.25874 9.17241 6.61618L10.157 7.14213ZM11.6898 4.17207C11.9178 4.24533 12.0798 4.42146 12.133 4.62667L13.2135 4.34639C13.0606 3.75697 12.6095 3.29505 12.0313 3.10929L11.6898 4.17207ZM11.0472 4.40518C11.0733 4.3047 11.1459 4.21237 11.2557 4.15947L10.7711 3.15386C10.3751 3.34462 10.0778 3.69676 9.96674 4.12489L11.0472 4.40518ZM11.2557 4.15947C11.3559 4.11115 11.4739 4.10274 11.5819 4.13742L11.9234 3.07464C11.544 2.95278 11.1302 2.9808 10.7711 3.15386L11.2557 4.15947ZM12.8586 10.2441H16.7143V9.12777H12.8586V10.2441ZM5.83725 17.9999L5.1142 9.63784L4.00208 9.73399L4.72513 18.096L5.83725 17.9999ZM5.11628 18.0792V9.68591H4V18.0792H5.11628ZM4.72513 18.096C4.71531 17.9825 4.80481 17.8837 4.92034 17.8837V19C5.4606 19 5.8837 18.537 5.83725 17.9999L4.72513 18.096ZM13.2912 6.04572C13.3839 5.48004 13.3575 4.90123 13.2135 4.34639L12.133 4.62667C12.2379 5.03105 12.2572 5.45292 12.1896 5.86522L13.2912 6.04572ZM8.72287 17.8837C8.37019 17.8837 8.07517 17.6136 8.04464 17.2605L6.93251 17.3566C7.01285 18.2857 7.78992 19 8.72287 19V17.8837ZM8.74528 8.77179C9.25122 8.33581 9.79662 7.81687 10.157 7.14213L9.17241 6.61618C8.91464 7.09873 8.50419 7.50599 8.01659 7.92617L8.74528 8.77179ZM18.485 11.2329C18.675 10.1341 17.83 9.12777 16.7143 9.12777V10.2441C17.1359 10.2441 17.4573 10.6249 17.385 11.0427L18.485 11.2329ZM4.92034 17.8837C5.02915 17.8837 5.11628 17.9718 5.11628 18.0792H4C4 18.5872 4.41145 19 4.92034 19V17.8837ZM11.6965 8.87514C11.5791 9.59171 12.1314 10.2441 12.8586 10.2441V9.12777C12.8214 9.12777 12.7917 9.09414 12.7981 9.05563L11.6965 8.87514ZM7.44024 10.2705C7.42132 10.0518 7.50865 9.83743 7.67459 9.6944L6.9459 8.84880C6.50807 9.22609 6.27832 9.79092 6.32811 10.3667L7.44024 10.2705Z"
                    fill="#005FDA"
                  />
                  <path
                    d="M14.7556 18L8.25563 18.5L7.47215 18L6.96436 10L7.47215 9.5L8.75563 8L10.2556 6.5V4.5L11.2556 3.5L12.2556 4L12.7556 5L12.2556 9.5L12.7556 10L17.2556 9.5L17.7556 10.5L17.2556 15.5L14.7556 18Z"
                    fill="#005FDA"
                  />
                </svg>
              )
            ) : // Not Liked
            componentName === "ShoppingListPostCard" ? (
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.42307 7.01444L3.84457 6.97838C3.82505 6.75504 3.63119 6.58656 3.40484 6.59622C3.17848 6.60588 3 6.79026 3 7.01444H3.42307ZM13.1459 8.03204L12.7479 10.3091L13.5817 10.4518L13.9797 8.1747L13.1459 8.03204ZM9.20225 13.1628H6.57996V14H9.20225V13.1628ZM6.06586 12.6953L5.60772 7.45291L4.76472 7.52502L5.22286 12.7675L6.06586 12.6953ZM12.7479 10.3091C12.4621 11.9448 10.9714 13.1628 9.20225 13.1628V14C11.3606 14 13.2219 12.5103 13.5817 10.4518L12.7479 10.3091ZM9.20778 4.14892L8.83395 6.40635L9.66898 6.54172L10.0428 4.28429L9.20778 4.14892ZM5.78536 7.0208L6.59695 6.32884L6.0446 5.69463L5.23301 6.3866L5.78536 7.0208ZM8.07349 4.07743L8.34183 3.05388L7.52282 2.84366L7.25447 3.86721L8.07349 4.07743ZM8.74713 2.85306L8.82893 2.87906L9.08774 2.08197L9.00594 2.05598L8.74713 2.85306ZM7.66706 5.1066C7.843 4.78064 7.97968 4.43538 8.07349 4.07743L7.25447 3.86721C7.17755 4.16059 7.06544 4.44405 6.92071 4.71213L7.66706 5.1066ZM8.82893 2.87906C9.00177 2.934 9.12452 3.06609 9.16485 3.22L9.98392 3.00979C9.868 2.56773 9.52604 2.22129 9.08774 2.08197L8.82893 2.87906ZM8.34183 3.05388C8.36163 2.97853 8.41663 2.90928 8.49983 2.8696L8.13249 2.11539C7.8324 2.25847 7.60698 2.52257 7.52282 2.84366L8.34183 3.05388ZM8.49983 2.8696C8.57582 2.83336 8.66528 2.82705 8.74713 2.85306L9.00594 2.05598C8.71842 1.96458 8.40473 1.9856 8.13249 2.11539L8.49983 2.8696ZM9.71484 7.43304H12.6375V6.59583H9.71484V7.43304ZM4.39265 13.2499L3.84457 6.97838L3.00157 7.05049L3.54965 13.322L4.39265 13.2499ZM3.84615 13.3094V7.01444H3V13.3094H3.84615ZM3.54965 13.322C3.54221 13.2369 3.61005 13.1628 3.69762 13.1628V14C4.10714 14 4.42785 13.6528 4.39265 13.2499L3.54965 13.322ZM10.0428 4.28429C10.113 3.86003 10.093 3.42592 9.98392 3.00979L9.16485 3.22C9.24439 3.52329 9.259 3.83969 9.20778 4.14892L10.0428 4.28429ZM6.57996 13.1628C6.31263 13.1628 6.089 12.9602 6.06586 12.6953L5.22286 12.7675C5.28376 13.4643 5.87278 14 6.57996 14V13.1628ZM6.59695 6.32884C6.98045 6.00186 7.39387 5.61265 7.66706 5.1066L6.92071 4.71213C6.72532 5.07405 6.4142 5.37949 6.0446 5.69463L6.59695 6.32884ZM13.9797 8.1747C14.1237 7.3506 13.4832 6.59583 12.6375 6.59583V7.43304C12.9571 7.43304 13.2007 7.71864 13.1459 8.03204L13.9797 8.1747ZM3.69762 13.1628C3.7801 13.1628 3.84615 13.2289 3.84615 13.3094H3C3 13.6904 3.31188 14 3.69762 14V13.1628ZM8.83395 6.40635C8.74499 6.94378 9.16366 7.43304 9.71484 7.43304V6.59583C9.6867 6.59583 9.66419 6.57061 9.66898 6.54172L8.83395 6.40635ZM5.60772 7.45291C5.59338 7.28882 5.65958 7.12807 5.78536 7.0208L5.23301 6.3866C4.90113 6.66957 4.72698 7.09319 4.76472 7.52502L5.60772 7.45291Z"
                  fill="black"
                />
              </svg>
            ) : (
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ flexShrink: 0 }}
              >
                <path
                  d="M4.30228 9.68591L4.85834 9.63784C4.83259 9.34005 4.57683 9.11541 4.27822 9.1283C3.9796 9.14118 3.74414 9.38702 3.74414 9.68591H4.30228ZM17.1291 11.0427L16.6041 14.0788L17.7041 14.2691L18.2291 11.2329L17.1291 11.0427ZM11.9265 17.8837H8.46701V19H11.9265V17.8837ZM7.78878 17.2605L7.18438 10.2705L6.07225 10.3667L6.67665 17.3566L7.78878 17.2605ZM16.6041 14.0788C16.227 16.2597 14.2605 17.8837 11.9265 17.8837V19C14.7739 19 17.2294 17.0138 17.7041 14.2691L16.6041 14.0788ZM11.9338 5.86522L11.4406 8.87514L12.5422 9.05563L13.0354 6.04572L11.9338 5.86522ZM7.41873 9.6944L8.48942 8.77179L7.76073 7.92617L6.69004 8.84880L7.41873 9.6944ZM10.4374 5.7699L10.7914 4.40518L9.71088 4.12489L9.35685 5.48961L10.4374 5.7699ZM11.3261 4.13742L11.434 4.17207L11.7754 3.10929L11.6675 3.07464L11.3261 4.13742ZM9.90117 7.14213C10.1333 6.70752 10.3136 6.24717 10.4374 5.7699L9.35685 5.48961C9.25538 5.88079 9.10748 6.25874 8.91655 6.61618L9.90117 7.14213ZM11.434 4.17207C11.662 4.24533 11.8239 4.42146 11.8771 4.62667L12.9577 4.34639C12.8048 3.75697 12.3536 3.29505 11.7754 3.10929L11.434 4.17207ZM10.7914 4.40518C10.8175 4.3047 10.89 4.21237 10.9998 4.15947L10.5152 3.15386C10.1193 3.34462 9.82191 3.69676 9.71088 4.12489L10.7914 4.40518ZM10.9998 4.15947C11.1 4.11115 11.2181 4.10274 11.3261 4.13742L11.6675 3.07464C11.2882 2.95278 10.8743 2.9808 10.5152 3.15386L10.9998 4.15947ZM12.6027 10.2441H16.4584V9.12777H12.6027V10.2441ZM5.5814 17.9999L4.85834 9.63784L3.74622 9.73399L4.46927 18.096L5.5814 17.9999ZM4.86042 18.0792V9.68591H3.74414V18.0792H4.86042ZM4.46927 18.096C4.45945 17.9825 4.54895 17.8837 4.66448 17.8837V19C5.20474 19 5.62784 18.537 5.5814 17.9999L4.46927 18.096ZM13.0354 6.04572C13.128 5.48004 13.1016 4.90123 12.9577 4.34639L11.8771 4.62667C11.9821 5.03105 12.0013 5.45292 11.9338 5.86522L13.0354 6.04572ZM8.46701 17.8837C8.11433 17.8837 7.81931 17.6136 7.78878 17.2605L6.67665 17.3566C6.75699 18.2857 7.53406 19 8.46701 19V17.8837ZM8.48942 8.77179C8.99536 8.33581 9.54076 7.81687 9.90117 7.14213L8.91655 6.61618C8.65878 7.09873 8.24833 7.50599 7.76073 7.92617L8.48942 8.77179ZM18.2291 11.2329C18.4191 10.1341 17.5742 9.12777 16.4584 9.12777V10.2441C16.8801 10.2441 17.2014 10.6249 17.1291 11.0427L18.2291 11.2329ZM4.66448 17.8837C4.77329 17.8837 4.86042 17.9718 4.86042 18.0792H3.74414C3.74414 18.5872 4.15559 19 4.66448 19V17.8837ZM11.4406 8.87514C11.3232 9.59171 11.8756 10.2441 12.6027 10.2441V9.12777C12.5656 9.12777 12.5359 9.09414 12.5422 9.05563L11.4406 8.87514ZM7.18438 10.2705C7.16546 10.0518 7.25279 9.83743 7.41873 9.6944L6.69004 8.84880C6.25221 9.22609 6.02246 9.79092 6.07225 10.3667L7.18438 10.2705Z"
                  fill="black"
                />
              </svg>
            )}
            Like
          </div>
        )}

        {!user && (
          <Link
            className="nav-link my-0 pt-0 d-flex align-items-center gap-1"
            onClick={handleClick}
            style={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "16px",
              color: "#000000",
              textDecoration: "none",
            }}
          >
            <i className={`bi bi-hand-thumbs-up${isLiked ? "-fill" : ""}`}></i>
            Like
          </Link>
        )}

        {componentName === "ShoppingListPostCard" ? (
          <div
            className="nav-link my-0 pt-0 d-flex align-items-center gap-1 p-0"
            data-bs-toggle="collapse"
            style={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "14px",
              color: "#000000",
              textDecoration: "none",
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.4905 5.52773V9.22135C13.4905 10.6126 12.4028 11.7393 11.0598 11.7393H5.18617C4.59975 11.7393 4.0417 11.9842 3.62554 12.4055L3.181 12.8758C2.92562 13.1403 2.5 12.9542 2.5 12.5819V5.51792C2.5 4.12668 3.58771 3 4.93079 3H11.0692C12.4123 3 13.5 4.12668 13.5 5.51792L13.4905 5.52773Z"
                stroke="black"
                stroke-miterlimit="10"
              />
            </svg>
            Comment
          </div>
        ) : (
          <a
            className="nav-link my-0 pt-0 d-flex align-items-center gap-1 p-0"
            data-bs-toggle="collapse"
            href={`#multiCollapseExample${post?.id}`}
            role="button"
            aria-expanded="false"
            aria-controls={`multiCollapseExample${post?.id}`}
            style={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "16px",
              color: "#000000",
              textDecoration: "none",
            }}
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ flexShrink: 0 }}
            >
              <path
                d="M19.488 9.03327V13.4656C19.488 15.1351 18.1036 16.4872 16.3942 16.4872H8.91876C8.17241 16.4872 7.46217 16.7811 6.9325 17.2866L6.36673 17.851C6.0417 18.1684 5.5 17.945 5.5 17.4983V9.0215C5.5 7.35202 6.88436 6 8.59373 6H16.4063C18.1157 6 19.5 7.35202 19.5 9.0215L19.488 9.03327Z"
                stroke="black"
                strokeWidth="1.5"
                strokeMiterlimit="10"
              />
            </svg>
            Comment
          </a>
        )}

        <div
          className="nav-link my-0 pt-0 d-flex align-items-center gap-1 p-0"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            handleCopyLink();
          }}
          style={{
            fontFamily: "Inter",
            fontWeight: 400,
            fontSize:
              componentName === "ShoppingListPostCard" ? "14px" : "16px",
            color: "#000000",
            textDecoration: "none",
            cursor: "pointer",
          }}
        >
          {componentName === "ShoppingListPostCard" ? (
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.99906 8.00014C5.99906 8.73652 5.40211 9.33348 4.66573 9.33348C3.92935 9.33348 3.3324 8.73652 3.3324 8.00014C3.3324 7.26377 3.92935 6.66681 4.66573 6.66681C5.40211 6.66681 5.99906 7.26377 5.99906 8.00014Z"
                stroke="#14191F"
              />
              <path
                d="M9.33236 4.66681L5.99902 6.66681"
                stroke="#14191F"
                stroke-linecap="round"
              />
              <path
                d="M9.33236 11.3335L5.99902 9.3335"
                stroke="#14191F"
                stroke-linecap="round"
              />
              <path
                d="M11.9991 12.0001C11.9991 12.7365 11.4021 13.3335 10.6657 13.3335C9.92936 13.3335 9.3324 12.7365 9.3324 12.0001C9.3324 11.2638 9.92936 10.6668 10.6657 10.6668C11.4021 10.6668 11.9991 11.2638 11.9991 12.0001Z"
                stroke="#14191F"
              />
              <path
                d="M11.9991 4.00014C11.9991 4.73652 11.4021 5.33348 10.6657 5.33348C9.92936 5.33348 9.3324 4.73652 9.3324 4.00014C9.3324 3.26376 9.92936 2.66681 10.6657 2.66681C11.4021 2.66681 11.9991 3.26376 11.9991 4.00014Z"
                stroke="#14191F"
              />
            </svg>
          ) : (
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ flexShrink: 0 }}
            >
              <path
                d="M8.2487 11.0003C8.2487 12.0128 7.42789 12.8337 6.41536 12.8337C5.40284 12.8337 4.58203 12.0128 4.58203 11.0003C4.58203 9.98781 5.40284 9.16699 6.41536 9.16699C7.42789 9.16699 8.2487 9.98781 8.2487 11.0003Z"
                stroke="#14191F"
                strokeWidth="1.5"
              />
              <path
                d="M12.8319 6.41699L8.24854 9.16699"
                stroke="#14191F"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M12.8319 15.5835L8.24854 12.8335"
                stroke="#14191F"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M16.4987 16.5003C16.4987 17.5128 15.6779 18.3337 14.6654 18.3337C13.6529 18.3337 12.832 17.5128 12.832 16.5003C12.832 15.4878 13.6529 14.667 14.6654 14.667C15.6779 14.667 16.4987 15.4878 16.4987 16.5003Z"
                stroke="#14191F"
                strokeWidth="1.5"
              />
              <path
                d="M16.4987 5.50033C16.4987 6.51285 15.6779 7.33366 14.6654 7.33366C13.6529 7.33366 12.832 6.51285 12.832 5.50033C12.832 4.4878 13.6529 3.66699 14.6654 3.66699C15.6779 3.66699 16.4987 4.4878 16.4987 5.50033Z"
                stroke="#14191F"
                strokeWidth="1.5"
              />
            </svg>
          )}
          Share
        </div>
      </div>
      {/* <ul className="nav nav-stack py-3 small">
        <li className="nav-item">
          <Link className="nav-link " to="#!">
            {" "}
            <i className="bi bi-hand-thumbs-up-fill pe-1"></i> Liked (56)
          </Link>
        </li>
        <li className="nav-item ms-sm-auto">
          <Link className="nav-link" to="#!">
            {" "}
            <i className="bi bi-chat-fill pe-1"></i>Comments (12)
          </Link>
        </li>
      </ul> */}
      {/* Feed react END */}
      {/*  */}
      {/* <CommentModal
        show={showCommentModal}
        handleClose={handleClose}
        user={user}
        post={post}
        commentCount={commentCount}
        setCommentCount={setCommentCount}
      /> */}

      {/* Feed react END */}
    </>
  );
}
